export default class PaIndexGroupController {
  static list (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paIndexGroup/list', 'post', params, axiosOption, httpOption);
  }

  static groupList (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paIndexGroup/groupList', 'post', params, axiosOption, httpOption);
  }

  static view (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paIndexGroup/view', 'get', params, axiosOption, httpOption);
  }

  static export (sender, params, fileName) {
    return sender.download('/admin/app/paIndexGroup/export', params, fileName);
  }

  static add (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paIndexGroup/add', 'post', params, axiosOption, httpOption);
  }

  static update (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paIndexGroup/update', 'post', params, axiosOption, httpOption);
  }

  static delete (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paIndexGroup/delete', 'post', params, axiosOption, httpOption);
  }
}
